import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHydrateGlyph from './svgs/HydrateGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hydrateGlyph = (props => useIcon(SvgHydrateGlyph, SvgHydrateGlyph, props));

export { hydrateGlyph as default };
